import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import { ChecklistTemplateVersionMessages } from '../../content/components/message-design-b/message-design-b.utils';
import {
  ChecklistTemplateVersionAction
} from '../../states/checklist-template-version/checklist-template-version.action';
import { calcDefaultTimeoutOf } from '../../services/client/request-client.service';

export class SseChecklistTemplateVersionEvent extends SseEventBase {

  type: SseEventType = 'checklistTemplateVersion';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.CHECKLIST_TEMPLATE_VERSION_CREATE_SUCCESS: {
          const start = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            const message = ChecklistTemplateVersionMessages.NewVersion.success(resp.targetId);
            this.on.inProgressAsyncWorkFinished$.next(message);
          }, calcDefaultTimeoutOf(new Date(start)));
          this.store.dispatch(new ChecklistTemplateVersionAction.NewVersionFinished(resp.demandId));
          this.on.checklistTemplateAsyncWorkFinished$.next(resp.targetId);
          break;
        }

        case NotificationReasonEnum.CHECKLIST_TEMPLATE_VERSION_CREATE_FAILED: {
          const start = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.on.inProgressAsyncWorkFinished$.next(ChecklistTemplateVersionMessages.NewVersion.fail());
          }, calcDefaultTimeoutOf(new Date(start)));
          this.store.dispatch(new ChecklistTemplateVersionAction.NewVersionFinished(resp.demandId));
          break;
        }

        case NotificationReasonEnum.CHECKLIST_TEMPLATE_VERSION_RELEASE_SUCCESS: {
          const start = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            const message = ChecklistTemplateVersionMessages.ReleaseVersion.success(resp.targetId);
            this.on.inProgressAsyncWorkFinished$.next(message);
          }, calcDefaultTimeoutOf(new Date(start)));
          this.store.dispatch(new ChecklistTemplateVersionAction.ReleaseFinished(resp.demandId));
          this.on.checklistTemplateAsyncWorkFinished$.next(resp.targetId);
          break;
        }


        case NotificationReasonEnum.CHECKLIST_TEMPLATE_VERSION_RELEASE_FAILED: {
          const start = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.on.inProgressAsyncWorkFinished$.next(ChecklistTemplateVersionMessages.ReleaseVersion.fail());
          }, calcDefaultTimeoutOf(new Date(start)));
          this.store.dispatch(new ChecklistTemplateVersionAction.ReleaseFinished(resp.demandId));
          break;
        }

        case NotificationReasonEnum.CHECKLIST_TEMPLATE_VERSION_ARCHIVE_SUCCESS: {
          const start = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            const message = ChecklistTemplateVersionMessages.ArchiveVersion.success(resp.targetId);
            this.on.inProgressAsyncWorkFinished$.next(message);
          }, calcDefaultTimeoutOf(new Date(start)));
          this.store.dispatch(new ChecklistTemplateVersionAction.ArchiveFinished(resp.demandId));
          this.on.checklistTemplateAsyncWorkFinished$.next(resp.targetId);
          break;
        }

        case NotificationReasonEnum.CHECKLIST_TEMPLATE_VERSION_ARCHIVE_FAILED: {
          const start = this.inProgressMessageService.timestamp(resp.demandId);
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.on.inProgressAsyncWorkFinished$.next(ChecklistTemplateVersionMessages.ArchiveVersion.fail());
          }, calcDefaultTimeoutOf(new Date(start)));
          this.store.dispatch(new ChecklistTemplateVersionAction.ArchiveFinished(resp.demandId));
          break;
        }
      }
    });
  }
}
